export default __webpack_public_path__ + "ru-extra.5761b75bfbe92bb46eb8bba9acbdbb4c.json";